import React from 'react'

/**
 * formTouched: has the user changed anything on the form yet. CSS
 * :user-invalid can't drive this banner on its own - it only matches a
 * control once *that* control has been interacted with, so e.g. changing
 * Service alone wouldn't make an untouched, still-empty Mobile field count,
 * and the banner would wrongly stay hidden.
 */
const DefaultMessage = ({formTouched, confirm}) => {

    const displayMessage = formTouched && confirm === false;

    return (
        <>
            {displayMessage ? (
                <p
                    style={{color:'red',
                    fontSize: '20px',
                    fontWeight: 'bold'}}
                >
                        There are mandatory fields in this form, which contain required
                        information that you have not provided. You must complete these sections
                        to be able to submit this form. Please review the form and complete all of
                        the indicated fields.
                </p>
            ) : <></>}
        </>
    )
}

export default DefaultMessage;
